import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=13ebbc95&scoped=true&"
import script from "./detail.vue?vue&type=script&setup=true&lang=js&"
export * from "./detail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=13ebbc95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ebbc95",
  null
  
)

export default component.exports